import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../components/PageHeader';

function Accessibility() {
	return (
		<>
			<Helmet>
				<title>Accessibility | A-Z Home Improvement LLC</title>
				<meta name="description" content="Accessibility statement for A-Z Home Improvement LLC. Our website aims to meet WCAG 2.1 AA standards." />
			</Helmet>
			<PageHeader title="Accessibility Statement" subtitle="Our commitment to an inclusive online experience." />

			<section className="section">
				<div className="container" style={{ maxWidth: 720 }}>
					<h2>Our Commitment</h2>
					<p>A-Z Home Improvement LLC is committed to making our website accessible to everyone, including people with disabilities. We strive to meet the Web Content Accessibility Guidelines (WCAG) 2.1, Level AA as published by the World Wide Web Consortium (W3C).</p>

					<h2>Measures Taken</h2>
					<ul>
						<li>Semantic HTML elements used throughout the site for screen reader compatibility.</li>
						<li>All images include descriptive alt text.</li>
						<li>Color contrast ratios meet WCAG 2.1 AA minimums for normal and large text.</li>
						<li>All form fields are labeled and associated with their controls.</li>
						<li>Keyboard navigation is supported across all interactive elements.</li>
						<li>The site includes a "Skip to main content" mechanism.</li>
						<li>Text is scalable and reflowable on high zoom settings and mobile viewports.</li>
					</ul>

					<h2>Known Limitations</h2>
					<p>While we strive for full accessibility, some content may not yet fully comply with all WCAG 2.1 AA criteria. We are continuously working to improve our website. If you encounter any accessibility barriers, please contact us immediately.</p>

					<h2>Third-Party Content</h2>
					<p>Our website may include embedded content or third-party tools (such as map widgets or social media feeds) that are not under our direct control. We make reasonable efforts to ensure third-party elements are accessible, but cannot guarantee compliance for externally hosted content.</p>

					<h2>Feedback and Assistance</h2>
					<p>If you experience any difficulty accessing content on this website, or if you need information in an alternative format, please contact us. We will respond to accessibility feedback within 2 business days and work to resolve the issue promptly.</p>

					<address style={{ fontStyle: 'normal', background: '#f4f4f4', borderRadius: 8, padding: 20, marginTop: 10 }}>
						<strong>A-Z Home Improvement LLC</strong><br />
						3842 W. McDowell Rd, Suite 110<br />
						Phoenix, AZ 85009<br />
						Phone: <a href="tel:+16023902536" style={{ color: 'var(--brand)' }}>(602) 390-2536</a><br />
						Email: <a href="mailto:support@azhomefundingservices.com" style={{ color: 'var(--brand)' }}>support@azhomefundingservices.com</a>
					</address>

					<p style={{ marginTop: 20 }} className="helper">This statement was last reviewed in June 2025.</p>
				</div>
			</section>
		</>
	);
}

export default Accessibility;
